// Typography configuration for enterprise-grade website

export const typography = {
  fontFamily: '"Plus Jakarta Sans", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',

  // Display headings - for hero sections
  h1: {
    fontFamily: '"Plus Jakarta Sans", sans-serif',
    fontWeight: 800,
    fontSize: '3.5rem',
    lineHeight: 1.1,
    letterSpacing: '-0.02em',
    '@media (max-width:900px)': {
      fontSize: '2.5rem',
    },
    '@media (max-width:600px)': {
      fontSize: '2rem',
    },
  },

  // Section headings
  h2: {
    fontFamily: '"Plus Jakarta Sans", sans-serif',
    fontWeight: 700,
    fontSize: '2.75rem',
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
    '@media (max-width:900px)': {
      fontSize: '2.25rem',
    },
    '@media (max-width:600px)': {
      fontSize: '1.75rem',
    },
  },

  // Subsection headings
  h3: {
    fontFamily: '"Plus Jakarta Sans", sans-serif',
    fontWeight: 700,
    fontSize: '2rem',
    lineHeight: 1.3,
    letterSpacing: '-0.01em',
    '@media (max-width:600px)': {
      fontSize: '1.5rem',
    },
  },

  // Card titles
  h4: {
    fontFamily: '"Plus Jakarta Sans", sans-serif',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: 1.4,
    '@media (max-width:600px)': {
      fontSize: '1.25rem',
    },
  },

  // Small headings
  h5: {
    fontFamily: '"Plus Jakarta Sans", sans-serif',
    fontWeight: 600,
    fontSize: '1.25rem',
    lineHeight: 1.5,
  },

  h6: {
    fontFamily: '"Plus Jakarta Sans", sans-serif',
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: 1.5,
  },

  // Subtitle styles
  subtitle1: {
    fontFamily: '"Inter", sans-serif',
    fontWeight: 500,
    fontSize: '1.125rem',
    lineHeight: 1.6,
  },

  subtitle2: {
    fontFamily: '"Inter", sans-serif',
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.6,
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
  },

  // Body text
  body1: {
    fontFamily: '"Inter", sans-serif',
    fontWeight: 400,
    fontSize: '1.0625rem',
    lineHeight: 1.7,
  },

  body2: {
    fontFamily: '"Inter", sans-serif',
    fontWeight: 400,
    fontSize: '0.9375rem',
    lineHeight: 1.7,
  },

  // Button text
  button: {
    fontFamily: '"Inter", sans-serif',
    fontWeight: 600,
    fontSize: '0.9375rem',
    letterSpacing: '0.02em',
    textTransform: 'none',
  },

  // Caption and overline
  caption: {
    fontFamily: '"Inter", sans-serif',
    fontWeight: 400,
    fontSize: '0.8125rem',
    lineHeight: 1.5,
  },

  overline: {
    fontFamily: '"Inter", sans-serif',
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: 1.5,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
  },
};

export default typography;
